<template>
  <div>
    <!-- popup create schedule md-->
    <!-- <div
      class="custom-popup-class d-sm-down-none"
      v-if="popupscheduledetail === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <div class="p-3">
          <h3 class="custom-24px text-left text-white mt-2 p-2">
            <img
              src="../assets/img/iconBackWhite.svg"
              class="mr-2"
              @click="CloseSchedule()"
            />
            Create New Schedule
          </h3>
          <div v-if="popupform === true">
            <div class="p-1">
              <label class="custom-16px text-white mt-1">Schedule</label>

              <label class="custom-16px text-white mt-3">Schedule Name</label>
              <v-select
                v-model="selectedSubjects"
                :options="subjectsData"
                label="Name"
                placeholder="--Please Select Subject--"
                class="custom-vselect no-bordered"
              ></v-select>

              <label class="custom-16px text-white mt-1"
                >Repeat For Every</label
              >
              <input
                type="number"
                v-model="intervals"
                class="custom-input-user"
              />
              week

              <CRow>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Start Time</label>
                  <CInput type="datetime-local" v-model="ScheduleDateTimes" />
                </CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">End Time</label>
                  <CInput
                    type="datetime-local"
                    v-model="ScheduleDateTimeEnds"
                  />
                </CCol>
              </CRow>

              <label class="custom-16px text-white">Theme Color</label>
              <v-select
                v-model="selectedColor"
                :options="optionsColor"
                placeholder="--Please Select Theme--"
                class="custom-vselect no-bordered"
                label="Name"
              ></v-select>

              <label class="custom-16px text-white">Teacher</label>
              <v-select
                v-model="selectedTeacher"
                :options="teachers"
                label="Name"
                placeholder="--Please Select Teacher--"
                class="custom-vselect no-bordered"
              ></v-select>
              <br />
              <div class="text-center">
                <CButton
                  color="primary"
                  size="lg"
                  @click="SubmitSchedule"
                  class="custom-btn-login-active"
                  >Save
                </CButton>
                <br /><br />
              </div>
            </div>
          </div>
          <div v-if="popupsuccess === true">
            <div class="text-center" style="margin-top: 25%">
              <img src="../assets/img/checked.svg" />
              <h3 class="text-white">You're All Set !</h3>
              <label class="text-white"
                >New schedule succesfully created!</label
              >
              <CButton
                size="lg"
                @click="CloseSchedule()"
                class="custom-btn-login-active"
                >Close
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- popup list schedule md-->
    <!-- <div
      class="custom-popup-class d-sm-down-none"
      v-if="showDialog === true"
      style="z-index: 1"
    >
      <img
        src="../assets/img/iconBackWhite.svg"
        class="ml-2 mt-4 text-left"
        @click="CloseScheduleOpen()"
      />
      <div class="custom-24px text-center text-white">
        {{ date | moment("ddd") }} | {{ date | moment("DD/MM/YYYY") }}
      </div>
      <div class="card-custom-web">
        <CContainer>
          <br /><br />
          <div>
            <CRow v-if="popuplist === true">
              <CCol sm="12">
                <CCard
                  class="custom-bg-color-yellow m-1"
                  v-for="(item, index) in schedules"
                  v-bind:key="item.Id"
                  @click="OpenDetailSchedule(item.ID)"
                >
                  <CRow>
                    <CCol sm="3">
                      <div class="p-2">
                        <img
                          v-if="item.profileImagePath == ''"
                          style="
                            border: 1px solid #eee;
                            width: 60px;
                            height: 60px;
                            border-radius: 50%;
                            object-fit: cover;
                          "
                          src="../assets/img/default.png"
                          class="grey lighten-2 mt-2"
                        />

                        <img
                          v-else
                          style="
                            border: 3px solid #ddd;
                            background: #fff;
                            width: 60px;
                            height: 60px;
                            border-radius: 50%;
                            object-fit: cover;
                          "
                          :src="getPic(index)"
                          class="grey lighten-2"
                        />
                      </div>
                    </CCol>
                    <CCol sm="7">
                      <h6 class="text-left mt-2">
                        <strong> {{ item.title }}</strong>
                      </h6>
                      {{ item.start | moment("HH:mm") }} -
                      {{ item.end | moment("HH:mm") }}
                    </CCol>
                    <CCol sm="2">
                      <div class="mt-3">
                        <img
                          src="../assets/img/IconRight.svg"
                          style="height: 20px"
                          @click="OpenDetailSchedule(item.ID)"
                        />
                      </div>
                    </CCol>
                  </CRow>
                </CCard>
                <br /><br /><br />
                <br /><br /><br />
                <br /><br /><br />
              </CCol>
            </CRow>

            <div v-if="editschedule === true">
              <CCard class="p-2" v-if="ewall === 0">
                <CAlert color="danger" v-if="errorDate ===true"
                  >{{ labelMessageError }}</CAlert
                >
                <v-card>
                  <v-card-title>
                  </v-card-title>
                  <v-card-text>
                    <strong>Event details:</strong>
                    <br />
                    <br />
                        <CRow>
                      <CCol sm="2">
                        <img
                          :src="photoURLteacher"
                          width="50px"
                          height="50px"
                          style="border-radius: 30px"
                        />
                      </CCol>
                      <CCol sm="10">
                        <h5>
                          <strong>{{ teacherName }}</strong>
                        </h5>
                        {{ SubjectName }}
                      </CCol>
                    </CRow>
                    <br />
                    <CCard class="p-2">
                      <label><strong>Class Details</strong></label>
                      <div class="small text-muted" color="info">CLASS NAME</div>
                    <CInput v-model="SubjectName" disabled />
                    <div class="small text-muted">START DATE <label>Use 24Hour for safari only</label></div>
                    <CInput
                      type="datetime-local"
                      v-model="SelectedScheduleDateTime"
                    />
                    <div class="small text-muted">END DATE <label>Use 24Hour for safari only</label></div>
                    <CInput
                      type="datetime-local"
                      v-model="SelectedScheduleDateTimeEnd"
                    />
                    <CButton
                      block
                      type="submit"
                      size="lg"
                      color="success"
                      @click="UpdateSchedule"
                    >
                      Save Edit</CButton
                    >
                    <CButton
                      block
                      type="submit"
                      size="lg"
                      color="danger"
                      @click="DeleteSchedules()"
                    >
                      Remove</CButton
                    >
                      </CCard>

                   
                  </v-card-text>
                </v-card>
              </CCard>
              <CCard class="p-2" v-else>
                <CAlert color="danger"
                  >Plese note : You are not allowed to reschedule on this date
                  because thisschedulealready have attendance and charge ewallet
                  to parent</CAlert
                >
                <v-card>
                  <v-card-title> </v-card-title>
                  <v-card-text>
                    <strong>Event details:</strong>
                    <br />
                    <br />

                    <CRow>
                      <CCol sm="2">
                        <img
                          :src="photoURLteacher"
                          width="50px"
                          height="50px"
                          style="border-radius: 30px"
                        />
                      </CCol>
                      <CCol sm="10">
                        <h5>
                          <strong>{{ teacherName }}</strong>
                        </h5>
                        {{ SubjectName }}
                      </CCol>
                    </CRow>
                    <br />
                    <CCard class="p-2">
                      <label><strong>Class Details</strong></label>

                      <div class="small text-muted" color="info">CLASS NAME</div>
                    <CInput v-model="SubjectName" disabled />
                    <div class="small text-muted">START DATE <label>Use 24Hour for safari only</label></div>
                    <CInput
                      type="datetime-local"
                      v-model="SelectedScheduleDateTime"
                    />
                    <div class="small text-muted">END DATE  <label>Use 24Hour for safari only</label></div>
                    <CInput
                      type="datetime-local"
                      v-model="SelectedScheduleDateTimeEnd"
                    />
                    <CButton
                      block
                      type="submit"
                      size="lg"
                      color="success"
                      disabled
                    >
                      Save Edit</CButton
                    >
                    </CCard>

                   
                  </v-card-text>
                </v-card>
              </CCard>
            </div>
          </div>
        </CContainer>
      </div>
    </div> -->

    <h3 class="header-title">Class</h3>
    <label>Let’s see your class progress.</label>
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <span class="float-left">
                <img
                  src="../assets/img/iconnoti.svg"
                  class="ml-5 mr-2 mb-3 mt-3"
                />
                <span class="text-white mt-3 mb-2"> | </span>
              </span>

              <span class="float-left">
                <label class="ml-2 text-white mt-3 mb-2"
                  >Please check your students attendance for today class
                  <br /><br />
                  <CButton type="btn" class="btn-bg-white"
                    >Check Now</CButton
                  ></label
                >
                <br />
              </span>
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="position: absolute; top: 0; right: 100px; bottom: 0"
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
      <CRow>
        <CCol sm="12">
         

          <CRow class="mb-5">
            <CCol sm="12">
              <CCard class="mt-2">
                <CRow class="m-2">
                  <CCol sm="4" class="float-left">
                    <h5 class="custom-subtitle-card m-2">Schedule</h5></CCol
                  >
                  <CCol sm="8" class="float-right">
                    <CRow class="float-right">
                      <v-select
                        :options="teachers"
                        id="mySelect"
                        label="Name"
                        class="mr-2"
                        @input="FilteredTeachers(selectedTeachers.Name)"
                        v-model="selectedTeachers"
                      >
                        <template slot="option" slot-scope="option">
                          <img
                            v-if="option.profileImagePath == null"
                            style="
                              border: 1px solid #eee;
                              width: 20px;
                              height: 20px;
                              border-radius: 50%;
                              object-fit: cover;
                            "
                            src="../assets/img/default.png"
                            class="grey lighten-2 mt-2"
                          />

                          <img
                            v-else
                            style="
                              border: 3px solid #ddd;
                              background: #fff;
                              width: 20px;
                              height: 20px;
                              border-radius: 50%;
                              object-fit: cover;
                            "
                            :src="getPic(option)"
                            class="grey lighten-2 mt-2"
                          />
                          {{ option.Name }}
                        </template>
                      </v-select>

                      <v-select
                        v-model="selectedSubject"
                        :options="subjectOptions"
                        id="mySelect"
                        label="title"
                        class="mr-2"
                        @input="FilteredSubject()"
                      />
                      <CButton
                        color="primary"
                        type="button"
                        class="btn-blue-primary-noborder"
                        @click="GoOpenSchedule()"
                      >
                        + Create</CButton
                      >
                    </CRow>
                  </CCol>
                </CRow>

                <vue-cal
                  class="vuecal--white-theme"
                  :events="FilteredSubjects"
                  :time-from="7 * 60"
                  events-count-on-year-view="events-count-on-year-view"
                  events-on-month-view="long"
                  active-view="week"
                  :on-event-click="onEventClick"
                >
                  <template v-slot:no-event="">No event 👌</template>
                </vue-cal>
              </CCard>
            </CCol>
            <!-- <CCol sm="4">
              <CCard class="p-2 mt-2">
                <div v-if="showDialog1 == true">
                  <div v-if="selectedEvent.title == ''">
                    <div class="text-center">
                      <img
                        style="max-width: 70%"
                        src="../assets/img/noevent.jpg"
                      />
                      <br />
                      <h5 class="text-center">No selected event</h5>
                    </div>
                  </div>
                  <div v-else>
                    <h5>Detail schedule {{ date | moment("DD/MM/YYYY") }}</h5>
                    <v-card>
                      <v-card-title>
                        <v-icon>{{ selectedEvent.icon }}</v-icon>
                        <span>{{ selectedEvent.title }}</span>
                        <strong class="ml-2">{{
                          selectedEvent.start &&
                          selectedEvent.start.format("DD/MM/YYYY")
                        }}</strong>
                      </v-card-title>
                      <v-card-text>
                        <p v-html="selectedEvent.contentFull" />
                        <strong>Event details:</strong>
                        <ul>
                          <li>
                            Event starts at:
                            {{
                              selectedEvent.start &&
                              selectedEvent.start.formatTime()
                            }}
                          </li>
                          <li>
                            Event ends at:
                            {{
                              selectedEvent.end &&
                              selectedEvent.end.formatTime()
                            }}
                          </li>
                        </ul>

                        <div class="small text-muted" color="info">
                          CLASS NAME
                        </div>
                        <CInput v-model="SubjectName" disabled />
                        <div class="small text-muted">START DATE</div>
                        <CInput
                          type="datetime-local"
                          v-model="SelectedScheduleDateTime"
                        />
                        <div class="small text-muted">END DATE</div>
                        <CInput
                          type="datetime-local"
                          v-model="SelectedScheduleDateTimeEnd"
                        />
                        <CButton
                          block
                          type="submit"
                          size="lg"
                          color="success"
                          @click="UpdateSchedule"
                        >
                          Save Edit</CButton
                        >
                        <CButton
                          block
                          type="submit"
                          size="lg"
                          color="danger"
                          @click="OpenDeleteSchedule()"
                        >
                          Remove</CButton
                        >
                      </v-card-text>
                    </v-card>
                    <hr />
                    <h5 class="mt-3">
                      All list schedule {{ date | moment("DD/MM/YYYY") }}
                    </h5>
                    <ul v-for="item in schedules" v-bind:key="item.Id">
                      <li>
                        {{ item.start | moment("DD/MM/YYYY HH:mm") }} -
                        {{ item.end | moment("DD/MM/YYYY HH:mm") }} -
                        <span> {{ item.title }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div v-else>
                  <div class="text-center">
                    <img
                      style="max-width: 70%"
                      src="../assets/img/noevent.jpg"
                    />
                    <br />
                    <h5 class="text-center">No selected event</h5>
                  </div>
                </div>
              </CCard>
            </CCol> -->
          </CRow>

          <CModal title="Detail Schedule" size="md">
            <v-dialog v-model="showDialog">
              <v-card>
                <v-card-title>
                  <!-- <v-icon>{{ selectedEvent.icon }}</v-icon>
                  <span>{{ selectedEvent.title }}</span>
                  <v-spacer />
                  <strong class="ml-2">{{
                    selectedEvent.start &&
                    selectedEvent.start.format("DD/MM/YYYY")
                  }}</strong> -->
                </v-card-title>
                <v-card-text>
                  <!-- <p v-html="selectedEvent.contentFull" />
                  <strong>Event details:</strong>
                  <ul>
                    <li>
                      Event starts at:
                      {{
                        selectedEvent.start && selectedEvent.start.formatTime()
                      }}
                    </li>
                    <li>
                      Event ends at:
                      {{ selectedEvent.end && selectedEvent.end.formatTime() }}
                    </li>
                  </ul> -->

                  <div class="small text-muted" color="info">CLASS NAME</div>
                  <CInput v-model="SubjectName" disabled />
                  <div class="small text-muted">START DATE</div>
                  <CInput
                    type="datetime-local"
                    v-model="SelectedScheduleDateTime"
                  />
                  <div class="small text-muted">END DATE</div>
                  <CInput
                    type="datetime-local"
                    v-model="SelectedScheduleDateTimeEnd"
                  />
                  <CButton
                    block
                    type="submit"
                    size="lg"
                    color="success"
                    @click="UpdateSchedule"
                  >
                    Save Edit</CButton
                  >
                </v-card-text>
              </v-card>
            </v-dialog>
          </CModal>
        </CCol>
      </CRow>
    </div>
    <CModal size="md" :show.sync="DeleteSchedule">
      <div class="text-center">
        <h3 class="custom-title-popup" style="color: #000a2c">
          Delete Schedule
        </h3>
        <br />
      </div>
      <div class="text-center">
        <h4 class="sub-title-header" style="color: #000a2c">
          Are you sure you want to delete the<br />
          schedule?
        </h4>
        <br />
      </div>
      <template #footer>
        <div class="text-center">
          <CButton
            type="submit"
            size="lg"
            color="info"
            @click="DeleteSchedules()"
            >Yes, sure.</CButton
          >
        </div>
      </template>
    </CModal>


    <div v-if="showDialog" class="popup-all backdrop-all">
        <div class="popup-all1 p-4">
            <CRow class="align-items-center mb-3">

                <div style="width:100%" class="text-right">
                    <img src="../assets/img/close.png" style="max-width: 30px; cursor: pointer;" @click="closePopupShow" />
                </div>
            </CRow>
            <div v-if="editschedule === true">
              <div class="p-2" v-if="ewall === 0">
                <CAlert color="danger" v-if="errorDate ===true"
                  >{{ labelMessageError }}</CAlert
                >
                <v-card>
                  <v-card-text>
                    <strong>Event details:</strong>
                    <br />
                    <br />
                        <CRow>
                      <CCol sm="2">
                        <img
                          :src="photoURLteacher"
                          width="50px"
                          height="50px"
                          style="border-radius: 30px"
                        />
                      </CCol>
                      <CCol sm="10">
                        <h5>
                          <strong>{{ teacherName }}</strong>
                        </h5>
                        {{ SubjectName }}
                      </CCol>
                    </CRow>
                    <br />
                    <CCard class="p-2">
                      <label><strong>Class Details</strong></label>
                      <div class="small text-muted">CLASS NAME</div>
                    <CInput v-model="SubjectName" disabled />
                    <div class="small text-muted">START DATE <label>Use 24Hour for safari only</label></div>
                    <CInput
                      type="datetime-local"
                      v-model="SelectedScheduleDateTime"
                    />
                    <div class="small text-muted">END DATE <label>Use 24Hour for safari only</label></div>
                    <CInput
                      type="datetime-local"
                      v-model="SelectedScheduleDateTimeEnd"
                    />
                      </CCard>

                   
                  </v-card-text>
                </v-card>
              </div>
              <div class="p-2" v-else>
                <CAlert color="danger"
                  >Plese note : You are not allowed to reschedule on this date
                  because thisschedulealready have attendance and charge ewallet
                  to parent</CAlert
                >
                <v-card>
                  <v-card-title> </v-card-title>
                  <v-card-text>
                    <strong>Event details:</strong>
                    <br />
                    <br />

                    <CRow>
                      <CCol sm="2">
                        <img
                          :src="photoURLteacher"
                          width="50px"
                          height="50px"
                          style="border-radius: 30px"
                        />
                      </CCol>
                      <CCol sm="10">
                        <h5>
                          <strong>{{ teacherName }}</strong>
                        </h5>
                        {{ SubjectName }}
                      </CCol>
                    </CRow>
                    <br />
                    <CCard class="p-2">
                      <label><strong>Class Details</strong></label>

                      <div class="small text-muted" color="info">CLASS NAME</div>
                    <CInput v-model="SubjectName" disabled />
                    <div class="small text-muted">START DATE <label>Use 24Hour for safari only</label></div>
                    <CInput
                      type="datetime-local"
                      v-model="SelectedScheduleDateTime"
                    />
                    <div class="small text-muted">END DATE  <label>Use 24Hour for safari only</label></div>
                    <CInput
                      type="datetime-local"
                      v-model="SelectedScheduleDateTimeEnd"
                    />
                    <CButton
                      block
                      type="submit"
                      size="lg"
                      color="success"
                      disabled
                    >
                      Save Edit</CButton
                    >
                    </CCard>

                   
                  </v-card-text>
                </v-card>
              </div>
            </div>
            <div class="text-right">
            <CButton
                      type="submit"
                      size="lg"
                      color="success"
                      @click="UpdateSchedule"
                    >
                      Save Edit</CButton
                    >
                    <CButton
                      type="submit"
                      size="lg"
                      color="danger"
                      @click="DeleteSchedules()"
                      class="ml-2"
                    >
                      Remove</CButton
                    >
                  </div>
        </div>
    </div>

        <div v-if="popupscheduledetail" class="popup-all backdrop-all">
            <div class="popup-all1 p-4">
                <CRow class="align-items-center mb-3">
    
                    <div style="width:100%" class="text-right">
                        <img src="../assets/img/close.png" style="max-width: 30px; cursor: pointer;" @click="closePopupCreate" />
                    </div>
                </CRow>
          <h4 class="text-left">
           
            Create New Schedule
          </h4>
          <div v-if="popupform === true">
            <div class="p-1">

              <label class="mt-3 text-black">Schedule Name</label>
              <v-select
                v-model="selectedSubjects"
                :options="subjectsData"
                label="Name"
                placeholder="--Please Select Subject--"
                class="custom-vselect no-bordered"
              ></v-select>

              <label class="mt-3"
                >Repeat For Every</label
              >
              <input
                type="number"
                v-model="intervals"
                class="custom-input-user ml-2"
              />
              week

              <CRow>
                <CCol sm="6">
                  <label class="mt-3">Start Time</label>
                  <CInput type="datetime-local" v-model="ScheduleDateTimes" />
                </CCol>
                <CCol sm="6">
                  <label class="mt-3">End Time</label>
                  <CInput
                    type="datetime-local"
                    v-model="ScheduleDateTimeEnds"
                  />
                </CCol>
              </CRow>

              <label class="">Theme Color</label>
              <v-select
                v-model="selectedColor"
                :options="optionsColor"
                placeholder="--Please Select Theme--"
                class="custom-vselect no-bordered"
                label="Name"
              ></v-select>

              <label class="mt-2">Teacher</label>
              <v-select
                v-model="selectedTeacher"
                :options="teachers"
                label="Name"
                placeholder="--Please Select Teacher--"
                class="custom-vselect no-bordered"
              ></v-select>
              <br />
            </div>
          </div>
          <CButton
                        color="primary"
                        type="button"
                        class="btn-blue-primary-noborder"
                  @click="SubmitSchedule"
                  block
                  >Save
                </CButton>
        </div>
        </div>
  </div>
</template>



<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import VCalendar from "v-calendar";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.use(VuejsDialog);

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(require("vue-moment"));
import moment from "moment";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
    VCalendar,
    VueCal,
  },
  data() {
    return {
      schedule: [],
      feedData: [],
      Busy: false,
      DeleteSchedule: false,

      selectedSubject: "SELECT SUBJECT",
      subjectOptions: [],
      FilteredSubjects: [],

      selectedTeacher: "SELECT TEACHER",
      teacherOptions: [],
      selectedEvent: {},
      showDialog: false,
      schedules: [],

      SelectedScheduleDateTime: "",
      SelectedScheduleDateTimeEnd: "",

      teachers: [],
      selectedTeachers: "SELECT TEACHER",

      popupscheduledetail: false,
      ScheduleDateTime: "",
      ScheduleDateTimeEnd: "",
      selectedDay: "",
      ScheduleTime: "",
      ScheduleTimeEnd: "",
      interval: 0,
      StudentFee: 0,
      SubjectName: "",

      selectedTeacher: "",
      selectedColor: "",
      options: [
        {
          Id: 1,
          dayName: "Monday",
        },
        {
          Id: 2,
          dayName: "Tuesday",
        },
        {
          Id: 3,
          dayName: "Wednesday",
        },
        {
          Id: 4,
          dayName: "Thursday",
        },
        {
          Id: 5,
          dayName: "Friday",
        },
        {
          Id: 6,
          dayName: "Saturday",
        },
        {
          Id: 7,
          dayName: "Sunday",
        },
      ],
      optionsColor: [
        {
          Id: 1,
          Name: "blue",
        },
        {
          Id: 2,
          Name: "red",
        },
        {
          Id: 3,
          Name: "green",
        },
        {
          Id: 4,
          Name: "purple",
        },
        {
          Id: 5,
          Name: "violet",
        },
      ],
      popupform: true,
      selectedSubjects: "",
      subjectsData: [],
      popupsuccess: false,

      ScheduleDateTimes: "",
      ScheduleDateTimeEnds: "",
      intervals: 1,

      popupscheduleclasslist: false,
      editschedule: false,
      popuplist: false,

      ewall: 0,

      photoURLteacher: "",
      teacherName: "",

      errorDate: false,
      labelMessageError: 'Error Date'
    };
  },
  watch: {
  SelectedScheduleDateTime(newVal) {
    // Convert newVal to the desired format before updating the v-model
    this.SelectedScheduleDateTime = convertToISOFormat(newVal);
  },
  SelectedScheduleDateTimeEnd(newVal) {
    // Convert newVal to the desired format before updating the v-model
    this.SelectedScheduleDateTimeEnd = convertToISOFormat(newVal);
  },
},
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetScheduleStudent();
      this.GetTeacher();
      this.GetSubject();
    } else {
      this.GoToLogin();
    }
  },
  computed: {
    teacherName: {
      get: function () {
        var tea = this.teacherName;
        return tea;
      },
    },
    SubjectName: {
      get: function () {
        var tea = this.SubjectName;
        return tea;
      },
    },
  },
  methods: {
    GetTeacher() {
      this.Busy = true;
      this.$API
        .get(this.$ViewTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.teachers = response.data.filter((teacher) => teacher.Status === 'active');
           // this.teachers = this.teachers.filter((teacher) => teacher.Status === 'active');
            this.getPic(this.teachers);
          }
        });
    },

    getPic(option) {
      return "https://pickiddo.com" + option.profileImagePath;
    },
    GetScheduleStudent() {
      this.Busy = true;
      this.$API
        .get(this.$ViewSchedule, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.schedule = response.data;
            this.FilteredSubjects = this.schedule;

            var scheduleNames = _.uniq(_.map(response.data, "title"));
            scheduleNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.subjectOptions = scheduleNames;
            this.subjectOptions.unshift("SELECT SUBJECT");

            var teacherNames = _.uniq(_.map(response.data, "Teacher"));
            teacherNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.teacherOptions = teacherNames;
            this.teacherOptions.unshift("SELECT TEACHER");

            var combinedrates = [];
            for (let i in this.FilteredSubjects) {
              let item = this.FilteredSubjects[i];

              combinedrates.push({
                start: item.start,
                end: item.end,
                class: item.ThemeColor,
                title: item.title + "-" + item.Time,
                scheduleId: item.ScheduleId,
              });
            }

            this.FilteredSubjects = combinedrates;
          }
        });
    },
    onEventClick(event, e) {
      this.selectedEvent = event;
      this.scheduleId = event.scheduleId;
      this.date = moment(event.start).format("YYYY-MM-DD");

      this.$API
        .get(this.$EditSchedule + "?scheduleID=" + this.scheduleId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          console.log(this.info);

          if (response.status == 200 && this.info != null) {
            this.ClassName = this.info.ClassName;
            this.SubjectName = this.info.SubjectName;
            this.SelectedScheduleDateTime = this.info.ScheduleDateTime;
            this.SelectedScheduleDateTimeEnd = this.info.ScheduleDateTimeEnd;

            this.TuitionSubjectID = this.info.TuitionSubjectID;
          } else {
            console.log(this.info.detail);
          }
        });

      // this.$API
      //   .get(this.$ViewScheduleByDate + "?start=" + this.date, {
      //     withCredentials: true,
      //   })
      //   .then((response) => {
      //     if (response.status == 200 && response.data != null) {
      //       this.Busy = false;
      //       this.schedules = response.data;
      //       this.getPic(this.schedules);
      //     }
      //   });

      this.$API
        .get(this.$GetAttendanceEwallet + "?scheduleId=" + this.scheduleId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.ewall = response.data;
          }
        });

      this.$API
        .get(this.$EditSchedule + "?scheduleID=" + this.scheduleId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          console.log(this.info);

          if (response.status == 200 && this.info != null) {
            this.ClassName = this.info.ClassName;
            this.SubjectName = this.info.SubjectName;
            this.SelectedScheduleDateTime = this.info.ScheduleDateTime;
            this.SelectedScheduleDateTimeEnd = this.info.ScheduleDateTimeEnd;

            this.TuitionSubjectID = this.info.TuitionSubjectID;
            this.picturePath = this.info.profileImagePath;
            this.teacherName = this.info.TeacherName;

            console.log("test" + this.teacherName);

            this.photoURLteacher = "https://pickiddo.com/" + this.picturePath;
          } else {
            console.log(this.info.detail);
          }
        });

      this.showDialog = true;
      this.popuplist = false;
      this.editschedule = true;

      // Prevent navigating to narrower view (default vue-cal behavior).
      e.stopPropagation();
    },
    RefreshData() {
      this.GetScheduleStudent();
      this.selectedSubject = "";
      this.selectedTeacher = "";
    },

    FilteredSubject(event, e) {
      this.FilteredSubjects = this.schedule;
      var combinedrates = [];
      for (let i in this.FilteredSubjects) {
        let item = this.FilteredSubjects[i];

        combinedrates.push({
          start: item.start,
          end: item.end,
          title: item.title,
          class: item.ThemeColor,
          Teacher: item.Teacher,
          scheduleId: item.ScheduleId,
        });
      }

      this.FilteredSubjects = combinedrates;

      this.FilteredSubjects = _.filter(
        this.FilteredSubjects,
        (item) => item.title === this.selectedSubject
      );

      this.$API
        .get(this.$EditSchedule + "?scheduleID=" + item.scheduleId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          console.log(this.info);

          if (response.status == 200 && this.info != null) {
            this.ClassName = this.info.ClassName;
            this.SubjectName = this.info.SubjectName;
            this.SelectedScheduleDateTime = this.info.ScheduleDateTime;
            this.SelectedScheduleDateTimeEnd = this.info.ScheduleDateTimeEnd;

            this.TuitionSubjectID = this.info.TuitionSubjectID;
            console.log("testing" + this.SelectedScheduleDateTime);
          } else {
            console.log(this.info.detail);
          }
        });
    },

    FilteredTeacher() {
      console.log("masuk");
      this.FilteredSubjects = this.schedule;
      var combinedrates = [];
      for (let i in this.FilteredSubjects) {
        let item = this.FilteredSubjects[i];

        combinedrates.push({
          start: item.start,
          end: item.end,
          title: item.title + "-" + item.start,
          class: item.ThemeColor,
          Teacher: item.Teacher,
          scheduleId: item.ScheduleId,
        });
      }

      this.FilteredSubjects = combinedrates;

      this.FilteredSubjects = _.filter(
        this.FilteredSubjects,
        (item) => item.Teacher === this.selectedTeacher
      );

      this.$API
        .get(this.$EditSchedule + "?scheduleID=" + item.scheduleId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          console.log(this.info);

          if (response.status == 200 && this.info != null) {
            this.ClassName = this.info.ClassName;
            this.SubjectName = this.info.SubjectName;
            this.SelectedScheduleDateTime = this.info.ScheduleDateTime;
            this.SelectedScheduleDateTimeEnd = this.info.ScheduleDateTimeEnd;

            this.TuitionSubjectID = this.info.TuitionSubjectID;
            console.log("testing" + this.SelectedScheduleDateTime);
          } else {
            console.log(this.info.detail);
          }
        });
    },

    FilteredTeachers(event, e, Name) {
      console.log("Name" + this.selectedTeachers.Name);
      this.FilteredSubjects = this.schedule;
      var combinedrates = [];
      for (let i in this.FilteredSubjects) {
        let item = this.FilteredSubjects[i];

        combinedrates.push({
          start: item.start,
          end: item.end,
          title: item.title + "-" + item.Teacher,
          class: item.ThemeColor,
          Teacher: item.Teacher,
          scheduleId: item.ScheduleId,
        });
      }

      this.FilteredSubjects = combinedrates;

      this.FilteredSubjects = _.filter(
        this.FilteredSubjects,
        (item) => item.Teacher == this.selectedTeachers.Name
      );

      this.$API
        .get(this.$EditSchedule + "?scheduleID=" + item.scheduleId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          console.log(this.info);

          if (response.status == 200 && this.info != null) {
            this.ClassName = this.info.ClassName;
            this.SubjectName = this.info.SubjectName;
            this.SelectedScheduleDateTime = this.info.ScheduleDateTime;
            this.SelectedScheduleDateTimeEnd = this.info.ScheduleDateTimeEnd;

            this.TuitionSubjectID = this.info.TuitionSubjectID;
            console.log("testing" + this.SelectedScheduleDateTime);
          } else {
            console.log(this.info.detail);
          }
        });
    },
    UpdateSchedule() {
      const formData = new FormData();
      if (this.SelectedScheduleDateTime > this.SelectedScheduleDateTimeEnd) {
        this.errorDate = true;
        this.labelMessageError = 'Error: Due to End Date is less than Start Date';
      } 
    
      else if(this.SelectedScheduleDateTimeEnd == this.SelectedScheduleDateTime)
      {
        this.errorDate = true;
        this.labelMessageError = 'Error: Due to End Date is equal to Start Date';
      }
      else {
        formData.append("scheduleID", this.scheduleId);
        formData.append(
          "scheduleTime",
          moment(this.SelectedScheduleDateTime).format("DD/MM/YYYY HH:mm")
        );
        formData.append(
          "scheduleTimeEnd",
          moment(this.SelectedScheduleDateTimeEnd).format("DD/MM/YYYY HH:mm")
        );
        formData.append("subjectID", this.TuitionSubjectID);

        return this.$API
          .post(this.$UpdateSchedules, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.showDialog = false;
              this.RefreshData();
              this.$dialog.alert(response.data).then(function () {});
            }
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      }
    },
    DeleteSchedules() {
      const formData = new FormData();

      formData.append("Id", this.scheduleId);

      return this.$API
        .post(this.$DeleteSchedule, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$dialog.alert("Details Schedule Deleted!");
            this.RefreshData();
            this.showDialog = false;
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    OpenDeleteSchedule() {
      this.DeleteSchedule = true;
    },
    async SubmitSchedule() {
      this.Busy = true;
      const formData = new FormData();

      formData.append("TuitionSubjectId", this.selectedSubjects.SubjectId);

      formData.append("ScheduleDateTime", this.ScheduleDateTimes);

      formData.append("ScheduleDateTimeEnd", this.ScheduleDateTimeEnds);

      formData.append("TeacherId", this.selectedTeacher.Id);
      formData.append("ThemeColor", this.selectedColor.Name);

      formData.append("interval", this.intervals);
      return this.$API
        .post(this.$InsertScheduleNew, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.popupscheduledetail = false;
            this.$dialog.alert("Schedule Created!");
            this.GetScheduleStudent();
            this.Busy = false;
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    GetSubject() {
      return this.$API
        .get(this.$GetListSubjectTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjectsData = response.data;
          }
        });
    },
    CloseSchedule() {
      this.popupscheduledetail = false;
    },
    CloseScheduleOpen() {
      this.showDialog = false;
    },
    GoOpenSchedule() {
      this.popupsuccess = false;
      this.popupform = true;
      this.popupscheduledetail = true;
    },
    getPic(index) {
      return "https://pickiddo.com/" + this.schedules[index].profileImagePath;
    },
    OpenDetailSchedule(ID) {
      this.popuplist = false;
      this.editschedule = true;

      this.$API
        .get(this.$GetAttendanceEwallet + "?scheduleId=" + ID, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.ewall = response.data;
          }
        });

      this.$API
        .get(this.$EditSchedule + "?scheduleID=" + ID, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          console.log(this.info);

          if (response.status == 200 && this.info != null) {
            this.ClassName = this.info.ClassName;
            this.SubjectName = this.info.SubjectName;
            this.SelectedScheduleDateTime = this.info.ScheduleDateTime;
            this.SelectedScheduleDateTimeEnd = this.info.ScheduleDateTimeEnd;

            this.TuitionSubjectID = this.info.TuitionSubjectID;
            this.picturePath = this.info.profileImagePath;
            this.teacherName = this.info.TeacherName;

            console.log("test" + this.teacherName);

            this.photoURLteacher = "https://pickiddo.com/" + this.picturePath;
          } else {
            console.log(this.info.detail);
          }
        });
    },
    closePopupCreate()
    {
      this.popupscheduledetail = false;
    },
    closePopupShow()
    {
      this.showDialog = false;
    }
  },
};
</script>


<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
</style>



<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");

.vuecal__flex[column],
.vuecal__flex[grow] {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  width: -webkit-fill-available;
}
</style>

